/**
 * 認証エラークラス
 *
 * バックエンドAPIから返されるエラーをラップするカスタムエラークラス
 */
export class AuthError extends Error {
    code;
    details;
    /**
     * コンストラクタ
     *
     * @param code - エラーコード
     * @param message - エラーメッセージ
     * @param details - エラー詳細情報（オプション）
     */
    constructor(code, message, details) {
        super(message);
        this.code = code;
        this.details = details;
        this.name = "AuthError";
        Object.setPrototypeOf(this, AuthError.prototype);
    }
    /**
     * 認証エラーかどうかを判定
     *
     * @returns 認証エラーの場合true
     */
    isAuthenticationError() {
        return ["AUTH_001", "AUTH_002", "AUTH_003", "AUTH_004"].includes(this.code);
    }
    /**
     * 認可エラーかどうかを判定
     *
     * @returns 認可エラーの場合true
     */
    isAuthorizationError() {
        return this.code === "AUTH_006";
    }
    /**
     * アカウントロックエラーかどうかを判定
     *
     * @returns アカウントロックの場合true
     */
    isAccountLocked() {
        return this.code === "AUTH_005";
    }
    /**
     * レート制限エラーかどうかを判定
     *
     * @returns レート制限エラーの場合true
     */
    isRateLimited() {
        return this.code === "RATE_LIMIT_001";
    }
}
//# sourceMappingURL=AuthError.js.map